define('plugin/multiple-booking/model/MultipleBookingCartModel',['require','lib/model/BaseModel','model/BookingServerRequestModel','plugin/multiple-booking/model/MultipleBookingBatchModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var BookingServerRequestModel = require('model/BookingServerRequestModel');
    var MultipleBookingBatchModel = require('plugin/multiple-booking/model/MultipleBookingBatchModel');

    return BaseModel.extend({

        defaults: {
            key: 'multiple_booking',
            id: null,
            items: null,
            products: null,
            batch_model: null,
            request_model: null,
        },

        initialize: function () {
            BaseModel.prototype.initialize.call(this, arguments);

            //TODO implement triggering 'add:item' if necessary to expand cart in the header
            this.listenTo(this.get('items'), 'update reset sync', this.onItemsChange.bind(this, 'change'));
        },

        onItemsChange: function () {
            this.trigger('change');
            this.save();
        },

        isEmpty: function () {
            return !this.get('items') || this.get('items').length === 0;
        },

        getQty: function () {
            var items = this.get('items');
            if (!items || !items.length) return 0;

            return items.length;
        },

        getTax: function () {
            var items = this.get('items');
            if (!items || !items.length) return 0;

            return items.reduce(function (total, item) {
                var data = item.toJSON();

                var taxes = data.prices.totals ? data.prices.totals.taxes : [];
                
                return taxes.reduce(function (memo, tax) {
                    return memo + tax.amount;
                }, 0);
            }, 0);
        },

        getTotal: function () {
            if (!Config.getInstance().getOption('price_includes_tax')) {
                return this._getFullTotal() - this.getTax();
            } else {
                return this._getFullTotal();
            }
        },

        _getFullTotal: function () {
            var items = this.get('items');
            if (!items || !items.length) return 0;

            return items.reduce(function (total, item) {
                var data = item.toJSON();

                return total + (data.prices.totals ? data.prices.totals.total : 0);
            }, 0);
        },

        getCurrency: function () {
            // assume all items have same currency
            var items = this.get('items');
            if (!items || !items.length) return null;

            var currency = null;
            items.forEach(function (item) {
                var data = item.toJSON();

                if (data.prices.totals && data.prices.totals.currency) {
                    currency = data.prices.totals.currency;
                }
            });
            return currency;
        },

        load: function() {
            // return; //DEBUG
            var items = this.get('items') || new Backbone.Collection();
            var requestModel = this.get('request_model') || new BookingServerRequestModel();
            var batchModel = this.get('batch_model') || new MultipleBookingBatchModel();
            var _this = this;

            return new Promise(function (resolve, reject) {
                var stored = window.sessionStorage.getItem('multiple_booking_cart');

                if (stored) {
                    try {
                        var data = JSON.parse(stored);
                        if (data) {
                            
                            if (data.batch_model) {
                                batchModel.set(batchModel.parse(data.batch_model));
                                if (!_this.get('batch_model')) {
                                    _this.set('batch_model', batchModel);
                                }
                            }
                            if (data.request_model) {
                                requestModel.set(requestModel.parse(data.request_model));
                                if (!_this.get('request_model')) {
                                    _this.set('request_model', requestModel);
                                }
                                requestModel.set('batch_model', batchModel.toJSON());
                            }
                            // requestModel.parse(data.request_booking_model);
                        }
                        items.reset(data.items);
                        _this.trigger('sync');
                        resolve();
                    } catch (e) {
                        console.error(e);
                        reject();
                    }
                }
            });
        },

        save: function() {
            // return; //DEBUG
            var items = this.get('items');
            var requestModel = this.get('request_model');
            var batchModel = this.get('batch_model');

            window.sessionStorage.setItem('multiple_booking_cart', JSON.stringify({
                items: items ? items.toJSON() : null,
                request_model: requestModel ? requestModel.toJSON() : null,
                batch_model: batchModel ? batchModel.toJSON() : null
            }));
        },

        clear: function() {
            this.set({
                id: null,
                items: null,
                products: null,
                batch_model: null,
                request_model: null,
            });
            this.save();
        },
        
        getServiceIds: function() {
            var items = this.get('items');
            if (!items) return [];

            return items.map(function (item) {
                return item.get('service_id');
            }).reduce(function (a, b) {
				return a.concat(b);
			}, []);
        },

        getProductIds: function() {
            var items = this.get('items');
            if (!items) return [];

            return items.map(function (item) {
                return item.get('products');
            }).reduce(function (a, b) {
				return a.concat(b);
			}, []);
        }

    });

});
